import axios from "axiosStudent";

// Defines all states values
export const GET_STUDENT_DATA = "GET_STUDENT_DATA";

export const getStudentData = (id) => (dispatch) => { // get student dashboard data
  axios.get(`/student/${id}/dashboard`).then((res) => {
    dispatch({
      type: GET_STUDENT_DATA,
      payload: res.data,
    });
  });
};
